export function toDateTimeLocal(date) {
  const offset = date.getTimezoneOffset() * 60000; // offset in milliseconds
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}
export function getDatetimeFormatter() {
  const dateTimeFormat = Intl.DateTimeFormat(undefined, {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  function format(date) {
    if (!date) return;
    const dt = date instanceof Date ? date : new Date(date);
    return dateTimeFormat.format(dt);
  }
  return format;
}

const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;
const MS_PER_WEEK = 7 * MS_PER_DAY;

export function applyOffset(date, offset) {
  const {
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
  } = offset;

  const totalMs = weeks * MS_PER_WEEK +
    days * MS_PER_DAY +
    hours * MS_PER_HOUR +
    minutes * MS_PER_MINUTE;

  return new Date(date.getTime() + totalMs);
}

export function isSameMinute(a, b) {
  return Math.floor(a.getTime() / 60000) ===
    Math.floor(b.getTime() / 60000);
}

// Days are deliberately the largest unit (no weeks) so accumulated
// offsets stay easy to compare at a glance ("+8 days", not "+1 week 1 day").
const OFFSET_UNITS = [
  ["day", MS_PER_DAY / MS_PER_MINUTE],
  ["hour", MS_PER_HOUR / MS_PER_MINUTE],
  ["minute", 1],
];

// Human-readable offset between two dates, e.g. "+8 days", "-2 days 3 hours".
// Returns null when either date is missing/invalid or they fall on the same
// minute (matching the granularity used by isSameMinute).
export function describeOffset(base, target) {
  if (!(base instanceof Date) || !(target instanceof Date)) return null;
  if (isNaN(base.getTime()) || isNaN(target.getTime())) return null;
  const diffMinutes = Math.floor(target.getTime() / 60000) -
    Math.floor(base.getTime() / 60000);
  if (diffMinutes === 0) return null;
  const sign = diffMinutes < 0 ? "-" : "+";
  let remaining = Math.abs(diffMinutes);
  const parts = [];
  for (const [name, unitMinutes] of OFFSET_UNITS) {
    const count = Math.floor(remaining / unitMinutes);
    if (count > 0) {
      parts.push(`${count} ${name}${count === 1 ? "" : "s"}`);
      remaining -= count * unitMinutes;
    }
  }
  return `${sign}${parts.join(" ")}`;
}
